// extracted by mini-css-extract-plugin
export default {"inputContainer":"styles_inputContainer__jrQVj","inputLabel":"styles_inputLabel__Gepxa"};